export enum AnswerIds {
  // Health Impact
  HEALTH_IMPACT_IMPACTED_AREAS = "health-impact-impacted-areas",
  HEALTH_IMPACT_PHYSICAL_HEALTH_SYMPTOMS = "health-impact-physical-health-symptoms",
  HEALTH_IMPACT_MENTAL_HEALTH_SYMPTOMS = "health-impact-mental-health-symptoms",
  HEALTH_IMPACT_BEHAVIORAL_CHANGES = "health-impact-behavioral-changes",
  HEALTH_IMPACT_COGNITIVE_CHANGES = "health-impact-cognitive-changes",
  HEALTH_IMPACT_OTHER_SYMPTOMS = "health-impact-other-symptoms",
  HEALTH_IMPACT_OTHER_SYMPTOMS_CUSTOM = "health-impact-other-symptoms-custom",

  HEALTH_IMPACT_WORST_SYMPTOMS_DESCRIPTION = "health-impact-worst-symptoms-description",

  // Diabetes Inital Diagnosis
  HEALTH_IMPACT_TYPE_2_DIAGNOSIS_DIAGNOSED_DATE = "health-impact-type-2-diagnosis-diagnosed-date",
  HEALTH_IMPACT_TYPE_2_DIAGNOSIS_INITIAL_TESTS = "health-impact-type-2-diagnosis-inital-tests",
  HEALTH_IMPACT_TYPE_2_DIAGNOSED_A1C_VALUE = "health-impact-type-2-diagnosed-a1c-value",
  HEALTH_IMPACT_TYPE_2_DIAGNOSED_FPG_VALUE = "health-impact-type-2-diagnosed-fpg-value",
  HEALTH_IMPACT_TYPE_2_DIAGNOSED_OGTT_VALUE = "health-impact-type-2-diagnosed-ogtt-value",
  HEALTH_IMPACT_TYPE_2_DIAGNOSED_RPG_VALUE = "health-impact-type-2-diagnosed-rpg-value",
  HEALTH_IMPACT_TYPE_2_DIAGNOSED_HYPERGLYCEMIA_SYMPTOMS = "health-impact-type-2-diagnosed-hyperglycemia-symptoms",

  HEALTH_IMPACT_KNOWN_CAUSES = "health-impact-known-causes",
  HEALTH_IMPACT_DIAGNOSIS_SYMPTOMS_START = "health-impact-diagnosis-symptoms-start",
  HEALTH_IMPACT_DIAGNOSIS_DIAGNOSED_DATE = "health-impact-diagnosis-diagnosed-date",
  HEALTH_IMPACT_DIAGNOSIS_CONTRIBUTION_DESCRIPTION = "health-impact-diagnosis-contribution-description",

  HEALTH_IMPACT_USED_MEDICATION_BEFORE = "health-impact-used-medication-before",

  HEALTH_IMPACT_PAST_GLP1_TREATMENTS = "health-impact-past-glp1-treatments",
  HEALTH_IMPACT_PATIENT_PRE_GLP1_STARTING_WEIGHT = "health-impact-patient-pre-glp1-starting-weight",

  HEALTH_IMPACT_EXPERIENCE_WITH_MEDICATION_WHEN_START = "health-impact-experience-with-medication-when-start",
  HEALTH_IMPACT_EXPERIENCE_WITH_MEDICATION_HOW_LONG = "health-impact-experience-with-medication-how-long",
  HEALTH_IMPACT_EXPERIENCE_WITH_MEDICATION_HOW_IMPACTED_HEALTH = "health-impact-experience-with-medication-how-impacted-health",
  HEALTH_IMPACT_EXPERIENCE_WITH_MEDICATION_WHY_STOPPED_TAKING = "health-impact-experience-with-medication-why-stopped-taking",
  HEALTH_IMPACT_EXPERIENCE_WITH_MEDICATION_WHY_STOPPED_TAKING_OTHER = "health-impact-experience-with-medication-why-stopped-taking-other",

  HEALTH_IMPACT_PROVIDER_FIRST_NAME = "health-impact-provider-first-name",
  HEALTH_IMPACT_PROVIDER_LAST_NAME = "health-impact-provider-last-name",
  HEALTH_IMPACT_PROVIDER_SPECIALTY = "health-impact-provider-specialty",
  HEALTH_IMPACT_PROVIDER_RELATIONSHIP_DURATION = "health-impact-provider-relationship-duration",
  HEALTH_IMPACT_PROVIDER_CITY_AND_STATE = "health-impact-provider-city-and-state",

  HEALTH_IMPACT_PROVIDER_QUALIFICATIONS = "health-impact-provider-qualifications",
  HEALTH_IMPACT_PROVIDER_QUALIFICATIONS_DESCRIPTION = "health-impact-provider-qualifications-description",

  HEALTH_IMPACT_MIGRAINE_INITIAL_DAYS_PER_MONTH = "health-impact-migraine-initial-days-per-month",
  HEALTH_IMPACT_MIGRAINE_INITIAL_LASTS = "health-impact-migraine-initial-lasts",
  HEALTH_IMPACT_MIGRAINE_INITIAL_SEVERITY = "health-impact-migraine-initial-severity",

  HEALTH_IMPACT_MIGRAINE_CONTINUATION_DAYS_PER_MONTH_BEFORE = "health-impact-migraine-continuation-days-per-month-before",
  HEALTH_IMPACT_MIGRAINE_CONTINUATION_DAYS_PER_MONTH_AFTER = "health-impact-migraine-continuation-days-per-month-after",

  HEALTH_IMPACT_MIGRAINE_CONTINUATION_DURATION_BEFORE = "health-impact-migraine-continuation-duration-before",
  HEALTH_IMPACT_MIGRAINE_CONTINUATION_DURATION_AFTER = "health-impact-migraine-continuation-duration-after",

  HEALTH_IMPACT_MIGRAINE_CONTINUATION_PAIN_BEFORE = "health-impact-migraine-continuation-pain-before",
  HEALTH_IMPACT_MIGRAINE_CONTINUATION_PAIN_AFTER = "health-impact-migraine-continuation-pain-after",

  HEALTH_IMPACT_HAVE_OTHER_CONDITIONS = "health-impact-have-other-conditions",

  HEALTH_IMPACT_LIST_OTHER_CONDITIONS = "health-impact-list-other-conditions",

  // GLP1-s leaving this here so i don't lose track of them
  HEALTH_IMPACT_PATIENT_HEIGHT = "health-impact-patient-height",
  HEALTH_IMPACT_PATIENT_CURRENT_WEIGHT = "health-impact-patient-current-weight",
  HEALTH_IMPACT_PATIENT_PAST_YEAR_WEIGHT = "health-impact-patient-past-year-weight",
  HEALTH_IMPACT_PATIENT_HEAVIEST_WEIGHT = "health-impact-patient-heaviest-weight",
  HEALTH_IMPACT_PATIENT_AGE_DURING_HEAVIEST_WEIGHT = "health-impact-patient-age-during-heaviest-weight",
  HEALTH_IMPACT_MEDICATION_PREVIOUSLY_COVERED_BY_INSURANCE = "health-impact-previously-covered-by-insurance",
  HEALTH_IMPACT_PATIENT_MEDICATION_START_DATE = "health-impact-patient-medication-start-date",
  HEALTH_IMPACT_PATIENT_MEDICATION_STARTING_DOSE = "health-impact-patient-medication-starting-dose",

  HEALTH_IMPACT_PATIENT_MEDICATION_START_A1C_DATE = "health-impact-patient-medication-start-a1c-date",
  HEALTH_IMPACT_PATIENT_MEDICATION_STARTING_A1C_PERCENT = "health-impact-patient-medication-starting-a1c-percent",
  HEALTH_IMPACT_PATIENT_MEDICATION_LATEST_DOSE_DATE = "health-impact-patient-medication-latest-dose-date",
  HEALTH_IMPACT_PATIENT_MEDICATION_LATEST_DOSE = "health-impact-patient-medication-latest-dose",
  HEALTH_IMPACT_PATIENT_MEDICATION_LATEST_A1C_DATE = "health-impact-patient-medication-latest-a1c-date",
  HEALTH_IMPACT_PATIENT_MEDICATION_LATEST_A1C_PERCENT = "health-impact-patient-medication-latest-a1c-percent",

  HEALTH_IMPACT_PATIENT_MEDICATION_CURRENT_DOSE = "health-impact-patient-medication-current-dose",
  HEALTH_IMPACT_PATIENT_WEIGHT_AT_MEDICATION_START = "health-impact-patient-weight-at-medication-start",
  HEALTH_IMPACT_PATIENT_MONTHLY_DOSAGE_HISTORY = "health-impact-patient-monthly-dosage-history",
  HEALTH_IMPACT_PATIENT_MONTHLY_WEIGHT_HISTORY = "health-impact-patient-monthly-weight-history",
  HEALTH_IMPACT_PATIENT_PREDIABETES_DIAGNOSED_DATE = "health-impact-patient-prediabetes-diagnosed-date",
  HEALTH_IMPACT_PATIENT_PREDIABETES_LATEST_A1C_DATE = "health-impact-patient-prediabetes-latest-a1c-date",
  HEALTH_IMPACT_PATIENT_PREDIABETES_LATEST_A1C_VALUE = "health-impact-patient-prediabetes-latest-a1c-value",
  HEALTH_IMPACT_PATIENT_PREDIABETES_TAKING_MEDICATION_TO_TREAT_OR_MANAGE = "health-impact-patient-prediabetes-taking-medication-to-treat-or-manage",
  HEALTH_IMPACT_PATIENT_FAMILY_HISTORY_TYPE_TWO = "health-impact-patient-family-history-type-two",
  HEALTH_IMPACT_PATIENT_HAS_FAMILY_HISTORY_TYPE_TWO = "health-impact-patient-has-family-history-type-two",
  HEALTH_IMPACT_PATIENT_COMORBIDITIES = "health-impact-patient-comorbidities",
  HEALTH_IMPACT_PATIENT_GESTATIONAL_DIAGNOSIS_DATE = "health-impact-patient-gestational-diagnosis",
  HEALTH_IMPACT_PATIENT_GESTATIONAL_TAKING_MEDICATION_TO_TREAT_OR_MANAGE = "health-impact-patient-gestational-taking-medication-to-treat-or-manage",
  HEALTH_IMPACT_PATIENT_HEART_DISEASE_DIAGNOSED_DATE = "health-impact-patient-heart-disease-diagnosed-date",
  HEALTH_IMPACT_PATIENT_HEART_DISEASE_CONDITIONS_AND_EVENTS = "health-impact-patient-heart-disease-conditions-and-events",
  HEALTH_IMPACT_PATIENT_HEART_DISEASE_TAKING_MEDICATION_TO_TREAT_OR_MANAGE = "health-impact-patient-heart-disease-taking-medication-to-treat-or-manage",
  HEALTH_IMPACT_PATIENT_HEART_DISEASE_CLASSIFICATION = "health-impact-patient-heart-disease-classification",
  HEALTH_IMPACT_PATIENT_KIDNEY_DISEASE_DIAGNOSED_DATE = "health-impact-patient-kidney-disease-diagnosed-date",
  HEALTH_IMPACT_PATIENT_KIDNEY_DISEASE_CLASSIFICATION = "health-impact-patient-kidney-disease-classification",
  HEALTH_IMPACT_PATIENT_KIDNEY_DISEASE_TAKING_MEDICATION_TO_TREAT_OR_MANAGE = "health-impact-patient-kidney-disease-taking-medication-to-treat-or-manage",
  HEALTH_IMPACT_PATIENT_LIVER_DISEASE_DIAGNOSED_DATE = "health-impact-patient-liver-disease-diagnosed-date",
  HEALTH_IMPACT_PATIENT_LIVER_DISEASE_CONDITIONS_AND_EVENTS = "health-impact-patient-liver-disease-conditions-and-events",
  HEALTH_IMPACT_PATIENT_LIVER_DISEASE_TAKING_MEDICATION_TO_TREAT_OR_MANAGE = "health-impact-patient-liver-disease-taking-medication-to-treat-or-manage",
  HEALTH_IMPACT_PATIENT_SLEEP_APNEA_DIAGNOSED_DATE = "health-impact-patient-sleep-apnea-diagnosed-date",
  HEALTH_IMPACT_PATIENT_SLEEP_APNEA_TAKING_MEDICATION_TO_TREAT_OR_MANAGE = "health-impact-patient-sleep-apnea-taking-medication-to-treat-or-manage",
  HEALTH_IMPACT_CONTRAINDICATIONS_DO_YOU_HAVE_ACTIVE_PANCREATITIS = "health-impact-contraindications-do-you-have-active-pancreatitis",
  HEALTH_IMPACT_CONTRAINDICATIONS_UNCOMMON_CONDITIONS = "health-impact-contraindications-uncommon-conditions",
  HEALTH_IMPACT_PATIENT_REASON_UNABLE_TO_TAKE_RECOMMENDED_DOSAGE = "health-impact-patient-reason-unable-to-take-recommended-dosage",
  HEALTH_IMPACT_PATIENT_OTHER_REASON_UNABLE_TO_TAKE_RECOMMENDED_DOSAGE = "health-impact-patient-other-reason-unable-to-take-recommended-dosage",

  // need to add to prompt
  HEALTH_IMPACT_PATIENT_SLEEP_APNEA_LAST_STUDY_DATE = "health-impact-patient-sleep-apnea-last-study-date",
  HEALTH_IMPACT_PATIENT_SLEEP_APNEA_AHI = "health-impact-patient-sleep-apnea-ahi",

  // Lifestyle Changes
  LIFESTYLE_CHANGES_HAVE_YOU_MADE_CHANGES_TO_LOWER_YOUR_WEIGHT_IN_THE_PAST_YEAR = "lifestyle-changes-have-you-made-changes-to-lower-your-weight-in-the-past-year",
  LIFESTYLE_CHANGES_HOW_LONG_HAVE_YOU_BEEN_ON_THIS_PLAN = "lifestyle-changes-how-long-have-you-been-on-this-plan",
  LIFESTYLE_CHANGES_WHICH_PROGRAMS_HAVE_YOU_USED = "lifestyle-changes-which-programs-have-you-used",
  LIFESTYLE_CHANGES_WHICH_OTHER_PROGRAMS_HAVE_YOU_USED = "lifestyle-changes-which-other-programs-have-you-used",
  LIFESTYLE_CHANGES_WHICH_OTHER_PROGRAMS_WILL_YOU_CONTINUE = "lifestyle-changes-which-other-programs-will-you-continue",
  LIFESTYLE_CHANGES_WHICH_DIETS_ARE_YOU_CURRENTLY_FOLLOWING = "lifestyle-changes-which-diets-are-you-currently-following",
  LIFESTYLE_CHANGES_WHICH_OTHER_DIETS_ARE_YOU_CURRENTLY_FOLLOWING = "lifestyle-changes-which-other-diets-are-you-currently-following",
  LIFESTYLE_CHANGES_WHAT_EATING_CHALLENGES_HAVE_YOU_FACED = "lifestyle-changes-what-eating-challenges-have-you-faced",
  LIFESTYLE_CHANGES_WHAT_OTHER_EATING_CHALLENGES_HAVE_YOU_FACED = "lifestyle-changes-what-other-eating-challenges-have-you-faced",
  LIFESTYLE_CHANGES_DO_YOU_HAVE_UNIQUE_CHALLENGES_TO_PHYSICAL_ACTIVITY = "lifestyle-changes-do-you-have-unique-challenges-to-physical-activity",
  LIFESTYLE_CHANGES_HOW_MUCH_DO_YOU_EXERCISE_EACH_WEEK = "lifestyle-changes-how-much-do-you-exercise-each-week",
  LIFESTYLE_CHANGES_HAVE_YOU_HAD_A_GYM_OR_FITNESS_STUDIO_MEMBERSHIP = "lifestyle-changes-have-you-had-a-gym-or-fitness-studio-membership",
  LIFESTYLE_CHANGES_GYM_NAME = "lifestyle-changes-gym-name",
  LIFESTYLE_CHANGES_WILL_YOU_KEEP_UP_YOUR_HEALTHY_HABITS = "lifestyle-changes-will-you-keep-up-your-healthy-habits",
  LIFESTYLE_CHANGES_HOW_DO_YOU_STAY_ACTIVE_CARDIO = "lifestyle-changes-how-do-you-stay-active-cardio",
  LIFESTYLE_CHANGES_HOW_DO_YOU_STAY_ACTIVE_FUNCTIONAL = "lifestyle-changes-how-do-you-stay-active-functional",
  LIFESTYLE_CHANGES_HOW_DO_YOU_STAY_ACTIVE_STRENGTH = "lifestyle-changes-how-do-you-stay-active-strength",
  LIFESTYLE_CHANGES_HOW_DO_YOU_STAY_ACTIVE_SPORTS = "lifestyle-changes-how-do-you-stay-active-sports",
  LIFESTYLE_CHANGES_HOW_DO_YOU_STAY_ACTIVE_OTHER = "lifestyle-changes-how-do-you-stay-active-other",

  // CSID Specific
  HAS_TRIED_LOW_SUGAR_DIET = "has-tried-low-sugar-diet",

  // Daily Impact

  // this group for PANS/PANDAS patients
  DAILY_IMPACT_PATIENT_ACTIVITY_IMPACTS = "daily-impact-patient-activity-impacts",
  DAILY_IMPACT_PATIENT_SOCIAL_DESCRIPTION = "daily-impact-patient-social-description",
  DAILY_IMPACT_PATIENT_SELF_SUFFICIENCY_DESCRIPTION = "daily-impact-patient-self-sufficiency-description",
  DAILY_IMPACT_PATIENT_EDUCATION_DESCRIPTION = "daily-impact-patient-eduction-description",

  DAILY_IMPACT_DENIAL_IMPACTS = "daily-impact-denial-impacts",
  DAILY_IMPACT_DAILY_TASKS_DESCRIPTION = "daily-impact-daily-tasks-description",
  DAILY_IMPACT_FAMILY_DESCRIPTION = "daily-impact-family-description",
  DAILY_IMPACT_LEISURE_DESCRIPTION = "daily-impact-leisure-description",
  DAILY_IMPACT_SOCIAL_DESCRIPTION = "daily-impact-social-description",
  DAILY_IMPACT_EMPLOYMENT_DESCRIPTION = "employment-description",

  // Financial Impact

  // pans/pandsa/caregiver driven flow
  FINANCIAL_IMPACT_CAREGIVER_AFFECTED = "financial-impact-caregiver-affected",
  FINANCIAL_IMPACT_ADDITIONAL_CAREGIVER_FIRST_NAME = "financial-impact-additional-caregiver-first-name",
  FINANCIAL_IMPACT_ADDITIONAL_CAREGIVER_LAST_NAME = "financial-impact-additional-caregiver-last-name",
  FINANCIAL_IMPACT_ADDITIONAL_CAREGIVER_RELATIONSHIP = "financial-impact-additional-caregiver-relationship",
  FINANCIAL_IMPACT_CAREGIVER_IMPACT_CATEGORIES = "financial-impact-caregiver-impact-categories",
  FINANCIAL_IMPACT_CAREGIVER_IMPACT_OCCUPATION = "financial-impact-caregiver-impact-occupation",
  FINANCIAL_IMPACT_CAREGIVER_IMPACT_DESCRIPTION = "financial-impact-caregiver-impact-description",
  FINANCIAL_IMPACT_ADDITIONAL_CAREGIVER_IMPACT_CATEGORIES = "financial-impact-additional-caregiver-impact-categories",
  FINANCIAL_IMPACT_ADDITIONAL_CAREGIVER_IMPACT_OCCUPATION = "financial-impact-additional-caregiver-impact-occupation",
  FINANCIAL_IMPACT_ADDITIONAL_CAREGIVER_IMPACT_DESCRIPTION = "financial-impact-additional-caregiver-impact-description",

  FINANCIAL_IMPACT_EMPLOYMENT_STATUS = "financial-impact-employment-status",
  FINANCIAL_IMPACT_EMPLOYMENT_IMPACTS = "financial-impact-employment-impacts",
  FINANCIAL_IMPACT_CONDITION_CAUSED_WORK_STOPPAGE = "financial-impact-condition-caused-work-stoppage",
  FINANCIAL_IMPACT_EMPLOYMENT_DENIAL_IMPACT_OCCUPATION = "financial-impact-employment-denial-impact-occupation",
  FINANCIAL_IMPACT_EMPLOYMENT_DENIAL_IMPACT_DESCRIPTION = "financial-impact-employment-denial-impact-description",

  // Out of Network
  OUT_OF_NETWORK_PROVIDER_SEARCH_ADDITIONAL_INFO = "out-of-network-provider-search-additional-info",
  OUT_OF_NETWORK_ATTEMPTED_TO_FIND_NEW_PROVIDER = "out-of-network-attempted-to-find-new-provider",

  OUT_OF_NETWORK_PREFERRED_PROVIDER_FIRST_NAME = "out-of-network-preferred-provider-first-name",
  OUT_OF_NETWORK_PREFERRED_PROVIDER_LAST_NAME = "out-of-network-preferred-provider-last-name",
  OUT_OF_NETWORK_PREFERRED_PROVIDER_SPECIALTY = "out-of-network-preferred-provider-specialty",
  OUT_OF_NETWORK_PREFERRED_PROVIDER_RELATIONSHIP_DURATION = "out-of-network-preferred-provider-relationship-duration",
  OUT_OF_NETWORK_PREFERRED_PROVIDER_CITY_AND_STATE = "out-of-network-preferred-provider-city-and-state",

  OUT_OF_NETWORK_PROVIDER_SEARCH_NUM_OF_PROVIDERS_CONTACTED = "out-of-network-provider-search-num-of-providers-contacted",
  OUT_OF_NETWORK_PROVIDER_SEARCH_NUMBER_RECEIVING_PATIENTS = "out-of-network-provider-search-number-receiving-patients",
  OUT_OF_NETWORK_PROVIDER_SEARCH_NEXT_AVAILABLE_APPOINTMENT = "out-of-network-provider-search-next-available-appointment",
  OUT_OF_NETWORK_PROVIDER_SEARCH_DISTANCE_TO_APPOINTMENT = "out-of-network-provider-search-distance-to-appointment",

  OUT_OF_NETWORK_WHY_YOUR_PROVIDER = "out-of-network-why-your-provider",
  OUT_OF_NETWORK_WHY_YOUR_PROVIDER_DESCRIPTION = "out-of-network-why-your-provider-description",

  // Site of Care
  SITE_OF_CARE_WHY_PROVIDER_QUALIFIED = "site-of-care-why-provider-qualified",
  SITE_OF_CARE_WHY_PROVIDER_QUALIFIED_DESCRIPTION = "site-of-care-why-provider-qualified-description",

  SITE_OF_CARE_ASKED_TO_SWITCH_TO = "site-of-care-asked-to-switch-to",
  SITE_OF_CARE_NAME_OF_NEW_FACILITY = "site-of-care-name-of-new-facility",
  SITE_OF_CARE_CONCERNS_WITH_SWITCHING = "site-of-care-concerns-with-switching",

  // Step Therapy
  STEP_THERAPY_PAST_MEDICATIONS_TRIED = "past-medications-tried",
  STEP_THERAPY_PAST_MEDICATIONS_TRIED_OTHERS = "past-medications-tried-others",

  STEP_THERAPY_MEDICATIONS_DENIED_FOR = "step-therapy-denial-medications",
  STEP_THERAPY_MEDICATIONS_DENIED_FOR_CUSTOM = "step-therapy-denial-medications-custom",

  STEP_THERAPY_MISSED_STEP_HAVE_NOT_TRIED = "step-therapy-missed-step-have-not-tried",
  STEP_THERAPY_MISSED_STEP_REASON_TO_SKIP = "step-therapy-reason-to-skip-step",
  STEP_THERAPY_MISSED_STEP_REASON_TO_SKIP_DENIED_FOR = "step-therapy-reason-to-skip-step-denied-for",

  STEP_THERAPY_EXPERIENCE_WITH_MEDICATION_WHEN = "step-therapy-experience-with-medication-when",
  STEP_THERAPY_EXPERIENCE_WITH_MEDICATION_HOW_LONG_TAKING = "step-therapy-experience-with-medication-how-long",
  STEP_THERAPY_EXPERIENCE_WITH_MEDICATION_WHY_STOP = "step-therapy-experience-with-medication-why-stop",
  STEP_THERAPY_EXPERIENCE_WITH_MEDICATION_HOW_LONG_TRIED = "step-therapy-experience-with-medication-how-long-tried",

  STEP_THERAPY_STOPPED_TAKING_SIDE_EFFECTS = `step-therapy-stopped-taking-side-effects`,
  STEP_THERAPY_STOPPED_TAKING_SIDE_EFFECTS_DESCRIPTION = `step-therapy-stopped-taking-side-effects-description`,

  STEP_THERAPY_WARNED_AGAINST_TAKING_WITH_OTHER_MED_NAME = `step-therapy-warned-against-taking-with-other-med-name`,
  STEP_THERAPY_WARNED_AGAINST_TAKING_WITH_OTHER_MED_NAME_DESCRIPTION = `step-therapy-warned-against-taking-with-other-med-description`,

  STEP_THERAPY_WORSENS_ANOTHER_CONDITION = `step-therapy-worsens-another-condition`,
  STEP_THERAPY_WORSENS_ANOTHER_CONDITION_DESCRIPTION = `step-therapy-worsens-another-condition-description`,

  STEP_THERAPY_CONFLICT_WITH_MEDICATION_PLAN = `step-therapy-conflict-with-medication-plan`,

  // Less Common Situations
  LESS_COMMON_SITUATIONS_HAVE_NEEDED_EMERGENCY_CARE = "less-common-situations-have-needed-emergency-care",
  LESS_COMMON_SITUATIONS_EMERGENCY_SITUATION_EXPLANATION = "less-common-situations-emergency-situation-explanation",

  LESS_COMMON_SITUATIONS_UNCOMMON_OCCURRENCES = "less-common-situations-uncommon-occurrences",

  LESS_COMMON_SITUATIONS_EXPEDITE = "less-common-situations-expedite",
}
